import Select, { type MultiValue } from 'react-select';
import { type UserRoleDto } from '@/app/models/UserRoleDto';
import { useAudienceRoles } from '@/app/pages/notifications/announcements/core/_hooks';
import { roleIdsOf, unlistedRoleIds } from '@/app/pages/notifications/announcements/core/_utils';

type AnnouncementRoleSelectProps = {
  inputId: string;
  value: string[];
  disabled: boolean;
  onChange: (userRoleIds: string[]) => void;
};

function AnnouncementRoleSelect({ inputId, value, disabled, onChange }: AnnouncementRoleSelectProps) {
  const { data: roles = [], isPending } = useAudienceRoles();
  const selectedRoleIds = new Set(value);
  const selectedRoles = roles.filter((role) => role.id && selectedRoleIds.has(role.id));
  // A função fora da lista carregada não aparece no select, mas continua no público ao mudar a seleção.
  const keptRoleIds = unlistedRoleIds(roles, value);

  const changeRoles = (nextRoles: MultiValue<UserRoleDto>) => {
    const chosenRoleIds = roleIdsOf([...nextRoles]);
    onChange([...keptRoleIds, ...chosenRoleIds]);
  };

  return (
    <div className="announcement-audience-select position-relative">
      <i aria-hidden="true" className="bi bi-search text-muted position-absolute pe-none" />
      <Select<UserRoleDto, true>
        isMulti
        className="react-select-styled"
        classNamePrefix="react-select"
        getOptionLabel={(role) => role.name ?? ''}
        getOptionValue={(role) => role.id ?? ''}
        inputId={inputId}
        isDisabled={disabled}
        isLoading={isPending}
        noOptionsMessage={() => 'Nenhum perfil encontrado'}
        options={roles}
        placeholder="Buscar funções…"
        value={selectedRoles}
        onChange={changeRoles}
      />
    </div>
  );
}

export default AnnouncementRoleSelect;
